export default __webpack_public_path__ + "static/media/w.2e6f0359.svg";